const InboxIconSVG = ({ className }) => (
    <svg
        className={className}
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M2.73192 9.03886C2.72601 7.3006 2.77517 5.56258 2.87935 3.82743C2.92666 3.02966 3.26502 2.27697 3.83027 1.71203C4.39553 1.14709 5.14841 0.809156 5.94621 0.762289C9.24037 0.563938 12.5435 0.563938 15.8376 0.762289C16.6357 0.808751 17.389 1.1465 17.9546 1.71149C18.5203 2.27647 18.8589 3.02938 18.9062 3.82743C19.0091 5.588 19.0605 7.31258 19.0536 9.03886M8.42335 9.28572H13.3605M8.42335 5.17143H13.3605"
            stroke="currentColor"
            strokeOpacity="1"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M1.29029 7.88525L8.75086 13.7858C9.35482 14.2634 10.102 14.5238 10.872 14.5251C11.6419 14.5263 12.3899 14.2683 12.9954 13.7927L20.504 7.89554C20.7303 8.23668 20.8897 8.62411 20.9583 9.04754C21.1811 10.4155 21.2857 11.8298 21.2857 13.7841C21.2857 15.7384 21.1829 17.1544 20.96 18.5224C20.7371 19.8767 19.5971 20.8744 18.2326 21.0304C15.8703 21.2995 13.4154 21.5001 10.8937 21.5001C8.37029 21.5001 5.91543 21.2995 3.55314 21.0304C2.18857 20.8761 1.04857 19.8767 0.827429 18.5224C0.604571 17.1544 0.5 15.7401 0.5 13.7841C0.5 11.8281 0.602857 10.4155 0.825714 9.04754C0.897714 8.61897 1.05886 8.22811 1.29029 7.88525Z"
            stroke="currentColor"
            strokeOpacity="1"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default InboxIconSVG;
